import axios from 'axios'
import ErrorTooManyRequests from '@/shared/errors/ErrorTooManyRequests'
import { globalErrorForMetrics } from '@/store/globalErrorForMetrics'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.VUE_APP_API_URL || '',
  // timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
  headers: {
    'Qic-Product-Code': 'qarenew'
  }
}
const httpClient = axios.create(config)

httpClient.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
httpClient.interceptors.response.use(
  function (response) {
    if (response.data && response.data.success !== undefined && !response.data.success) {
      if (response.data.errorMessage === '1010') {
        throw new Error(`CUSTOM_ERROR=1010?quoteno=${response.data.quoteno}`)
      } else {
        throw new Error(response.data.errorMessage || 'no_name_error', { cause: { data: response.data } })
      }
    }

    return response
  },
  function (error) {
    globalErrorForMetrics.error_code = error?.response?.status
    globalErrorForMetrics.error_message = error?.response?.data?.errorMessage
    if (error?.response?.status === 429) {
      throw new ErrorTooManyRequests(error?.response?.response?.errorMessage || 'Too Many Requests')
    }

    const errorData = {
      defaultError: 'network_error',
      data: error.response?.data
    }
    return Promise.reject(errorData)
  }
)

export default httpClient
